/* Búsqueda inteligente DigitalCore: multi-palabra, coincide con cualquiera,
   ignora mayúsculas/minúsculas y tildes. Carga el índice completo del
   catálogo una sola vez (cacheado en sessionStorage) y filtra en el navegador. */
(function () {
  var INDEX_URL = '/pages/catalogo-busqueda';
  var CACHE_KEY = 'dc-search-index-v1';
  var indexPromise = null;

  var DIACRITICS_RE = new RegExp('[' + String.fromCharCode(0x0300) + '-' + String.fromCharCode(0x036f) + ']', 'g');

  function normalize(text) {
    return (text || '')
      .toString()
      .normalize('NFD')
      .replace(DIACRITICS_RE, '')
      .toLowerCase();
  }

  function fetchAllPages(url, acc) {
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var next = acc.concat(data.products || []);
        if (data.next_page) {
          return fetchAllPages(data.next_page, next);
        }
        return next;
      });
  }

  function loadIndex() {
    if (indexPromise) return indexPromise;

    try {
      var cached = sessionStorage.getItem(CACHE_KEY);
      if (cached) {
        var parsed = JSON.parse(cached);
        indexPromise = Promise.resolve(parsed);
        return indexPromise;
      }
    } catch (e) {
      /* sessionStorage no disponible, seguimos sin cache */
    }

    indexPromise = fetchAllPages(INDEX_URL, []).then(function (products) {
      var normalized = products.map(function (p) {
        return {
          title: p.title,
          handle: p.handle,
          url: p.url,
          image: p.image,
          price: p.price,
          type: p.type,
          _norm: normalize(p.title)
        };
      });
      try {
        sessionStorage.setItem(CACHE_KEY, JSON.stringify(normalized));
      } catch (e) {
        /* catálogo muy grande para sessionStorage, se ignora el cache */
      }
      return normalized;
    });

    return indexPromise;
  }

  function search(query, products) {
    var words = normalize(query).split(/\s+/).filter(Boolean);
    if (words.length === 0) return [];

    var results = [];
    for (var i = 0; i < products.length; i++) {
      var p = products[i];
      var matches = 0;
      for (var w = 0; w < words.length; w++) {
        if (p._norm.indexOf(words[w]) !== -1) matches++;
      }
      if (matches > 0) {
        results.push({ product: p, matches: matches });
      }
    }

    results.sort(function (a, b) {
      if (b.matches !== a.matches) return b.matches - a.matches;
      return a.product.title.localeCompare(b.product.title);
    });

    return results.map(function (r) { return r.product; });
  }

  window.DCSmartSearch = {
    normalize: normalize,
    loadIndex: loadIndex,
    search: search
  };

  /* Precarga el índice en segundo plano cuando el navegador está libre,
     para que la primera búsqueda del usuario sea instantánea. */
  if ('requestIdleCallback' in window) {
    requestIdleCallback(loadIndex, { timeout: 4000 });
  } else {
    setTimeout(loadIndex, 1500);
  }
})();
